<template>
	<div class="update" v-if="!isEdit">

		<!-- <div class="add-cell">
			<el-button class="add-btn" @click="handleAddArticle"> <span>+</span>添加文章</el-button>
		</div> -->
		<el-table
			ref="cardTabel"
			:data="list"
			class="list qjc-fts-14"
			header-cell-class-name="list-header qjc-ftw-500 qjc-c-dark" >
			
			<!-- height="800px" -->
			<el-table-column prop="id" label="编号" width="100px" class-name="id">
				<template slot-scope="scope">
					<div class="article-id">
						{{scope.row.id ? scope.row.id : ''}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="title" label="标题" class-name="title">
				<template slot-scope="scope">
					<div class="article-title" :title="scope.row.title ? scope.row.title : ''">
						{{scope.row.title ? scope.row.title : '--'}}
					</div>
				</template>
			</el-table-column>
			
			<el-table-column prop="status" label="状态" width="120px" class-name="status">
				<template slot-scope="scope">
					<div class="show-btn-cell">
						<div v-if="scope.row.status == 1" class="show-btn" >显示</div>
						<div v-else class="not-show-btn" >不显示</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="sort" label="排序" width="120px" class-name="sort">
				<template slot-scope="scope">
					{{ scope.row.sort ? scope.row.sort : '--' }}
				</template>
			</el-table-column>
			
			<el-table-column prop="updated_at" label="创建时间" width="250px"  class-name="updated_at">
				<template slot-scope="scope">
					{{ scope.row.updated_at ? scope.row.updated_at : '--' }}
				</template>
			</el-table-column>
			<el-table-column prop="remark" width="100px" label="操作" class-name="remark">
				<template slot-scope="scope">
					<div class="remarks-tabel">
						<div class="remarks-icon" @click="handleReviseRemark(scope.row)"><i class="el-icon-edit icon-hover"></i></div>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="select-cell">
			<!-- 分页组件 -->
			<el-pagination
				class="pagination qjc-texta-c"
				layout="prev, pager, next"
				hide-on-single-page
				:current-page.sync="pageData.page"
				:page-count="pageData.pagecount"
				:page-size="pageData.pagesize"
				:total="pageData.count"
				@current-change="pageChange"
			></el-pagination>
		</div>
		<!-- <article-edit v-if='isEdit' :close="handleClose" :form="itemForm" :id="reviseId" ></article-edit> -->
	</div>
	
	
</template>

<script>
import { getFaqList } from '@/utils/axios.js';

export default {
	name: 'mainScience',
	components: {
		
	},
	data() {
		return {
			submiting: false, // 正在请求
			list: [], //列表
			pageData: {
				count: 0, // 总条数
				page: 1, // 当前页
				pagecount: 0, // 总页数
				pagesize: 10 // 每页条数
			},
			itemForm: {},
			isEdit: false,
			reviseId: '', //当前选中Id
		};
	},

	mounted() {
		this.getList();
	},
	watch: {},
	methods: {
		// 新增文章
		handleAddArticle() {
			this.reviseId = '',
			this.isEdit = true;
			this.itemForm = {};
		},
		// 关闭文章编辑并重置表单
		handleClose() {
			this.id = '';
			this.itemForm = {};
			this.isEdit = false;
			this.getList();
		},
		
		//获取列表信息
		getList() {
			// 正在请求
			this.submiting == true;

			getFaqList({
				page: this.pageData.page,
				pagesize: this.pageData.pagesize
			}).then(res => {
				// 请求成功
				this.submiting == false;
				if (res.code == 200) {
					this.list = res.data.data;
					// 分页
					var pager = res.data.pager;
					for (var key in pager) {
						pager[key] = parseInt(pager[key]);
					}
					this.pageData = pager;
				} else {
					this.$myAlert({
						type: 'fail',
						content: res.msg
					});
				}
			});
		},
		//获取单条文章信息
		handleReviseRemark(val) {
			this.reviseId = val.id;
			this.isEdit = true;
			this.$router.push('/mainScienceDetail?id=' + val.id)
		},
		// 列表切换
		pageChange(page) {
			this.pageData.page = page;
			this.allChecked = false; // 列表切换底部全选为false
			this.getList();
		}
	}
};
</script>

<style scoped>
.search >>> .el-input__inner {
	height: 36px;
	line-height: 14px;
	font-size: 14px;
	padding: 10px 12px;
	background-color: #fafbfc;
}

.list >>> .el-table__body,
.list >>> .el-table__footer,
.list >>> .el-table__header {
	table-layout: auto;
}
.list >>> .operate .cell {
	width: 84px;
	padding-left: 16px;
}
.list >>> .list-header {
	background-color: #fafbfc;
}
.list >>> .list-header .cell {
	line-height: 16px;
}
.pagination >>> button {
	width: 32px;
	height: 32px;
	line-height: 32px;
}
.pagination >>> button .el-icon {
	font-size: 14px;
}
.pagination >>> li {
	width: 32px;
	height: 32px;
	line-height: 32px;
	font-size: 14px;
	font-weight: 400;
	color: #40444d;
	border: 1px solid transparent;
	border-radius: 8px;
	margin: 0 6px;
	padding: 0;
	overflow: visible;
}
.pagination >>> li:hover,
.pagination >>> li.active {
	color: #6681fa;
	font-weight: 600;
	border-color: #6681fa;
	border-left: 1px solid #6681fa;
}

.remarks-tabel >>> input {
	border-width: 0 0 1px 0;
	border-radius: 0;
	padding: 0;
	background-color: transparent;
}
.list >>> input::-webkit-outer-spin-button,
.list >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.list >>> input[type="number"] {
  -moz-appearance: textfield;
}

.update >>> .el-table .cell {
	display: flex;
	align-items: center;
}


.article-img {
	width: 56px;
	height: 56px;
	background: #D8D8D8;
	border-radius: 2px;
}

.article-id {
	width: 40px;
	padding: 0 8px;
}

.article-code {
	width: 80px;
	
}

.list >>>.cell {
	padding: 0;
}

.add-cell {
	margin-top: 24px;
}

.add-btn {
	width: 200px;
	height: 48px;
	font-size: 16px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #FFFFFF;
	border-radius: 4px;
	background-color: #6681FA;
	border: none;
}

.add-btn span {
	font-size: 20px;
}

.article-title {
	/* width: 410px; */
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #777F8F;
	/* display: inline-block; */
	/* white-space: nowrap; */
	/* overflow: hidden; */
	/* text-overflow:ellipsis; */
	padding: 0 10px;
}

.show-btn-cell {
	display: flex;
	align-items: center;
	height: 34px;
}
/* .update >>> .el-table td, .update >>> .el-table th {
	padding: 8px 0;
} */

</style>
<style lang="scss" scoped>
.update {
	height: 100%;
	padding: 28px 24px;
	.back-list {
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
	
	.show-btn {
		position: relative;
		padding-left: 14px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		&::before {
			position: absolute;
			left: 0;
			top: 8px;
			content: '';
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background-color: #38E019;
		}
	}
	
	.not-show-btn {
		position: relative;
		padding-left: 14px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		&::before {
			position: absolute;
			left: 0;
			top: 8px;
			content: '';
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background-color: #FF5219;
		}
	}

	.search {
		display: flex;
		align-items: center;
		margin-top: 32px;

		.search-line {
			margin: 0 16px;
			color: #777f8f;
		}
		.el-input {
			width: 165px;
		}
		.el-button {
			width: 104px;
			height: 36px;
			line-height: 36px;
			font-size: 15px;
			padding: 0;
			margin-left: 16px;
		}
	}
	.list {
		color: #777f8f;
		// margin-top: 24px;

		.iconfont {
			font-size: 12px;

			&.delete-icon {
				position: relative;
				color: #777f8f;

				&::after {
					position: absolute;
					top: 50%;
					left: 50%;
					width: 100%;
					height: 2px;
					content: '';
					background-color: #ff4c52;
					border-radius: 1px;
					transform: translate(-50%, -50%);
				}
			}
		}
		.update-btn {
			cursor: pointer;
		}
	}
	.pagination {
		// margin-top: 0.24px;
	}

	.remarks-tabel {
		display: flex;
		align-items: center;

		.remarks-val {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #777f8f;
		}

		.remarks-input {
			width: 100px;
		}

		.remarks-icon {
			width: 20px;
			height: 20px;
			margin-left: 10px;
			cursor: pointer;
		}

		.status-tag {
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6681fa;
			margin-left: 16px;
			border: none;
			border-radius: 0;
			background-color: transparent;
		}
	}

	.icon-hover {
		color: #6681fa;
	}
}

.status-tip-text {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #777f8f;
	line-height: 24px;
}

.select-cell {
	display: flex;
	margin: 40px 0;
	justify-content: center;
	padding: 0 30px;
}

.check-all {
	margin-right: 20px;
}

.source-cell {
	// width: 140px;
	// display: inline-block;
	// white-space: nowrap;
	// overflow: hidden;
	// text-overflow: ellipsis;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #777F8F;
	line-height: 14px;
	padding-right: 10px;
}
</style>
